import { render, staticRenderFns } from "./NewLoggBtn.vue?vue&type=template&id=1237dffe&scoped=true&"
import script from "./NewLoggBtn.vue?vue&type=script&lang=js&"
export * from "./NewLoggBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237dffe",
  null
  
)

export default component.exports